import { useState } from "react";

import { Button } from "components/ui/Button";
import { Checkbox as CustomCheckbox } from "components/ui/Checkbox";

import checkboxIcon from "../../../../../ResultsTable/checkbox-icon.svg";
import styles from "./ResultDetails.module.css";

const parseResultValue = (value) => {
  if (!value) return "";
  return value
    .split(/\\\.br\\/g)
    .filter((line) => line.trim())
    .join("\n");
};

const combineResults = (results) => {
  if (!results || results.length === 0) return "-";

  return results
    .map((result) => {
      const testName = result.testName || "";
      const value = parseResultValue(result.value) || "";
      if (value) {
        return `${testName}: ${value}`;
      }
      return testName;
    })
    .filter(Boolean)
    .join("\n\n");
};

const getTestNames = (results) => {
  if (!results || results.length === 0) return "-";
  return results
    .map((result) => result.testName)
    .filter(Boolean)
    .join(", ");
};

const formatDateForForm = (dateString) => {
  if (!dateString) return "";
  const datePart = dateString.split(" ")[0];
  return datePart.replace(/\//g, "-");
};

export const RadiologyResultDetails = ({ items = [], addItemsToForm }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const hasItems = items.length > 0;

  const getItemId = (item) =>
    item.results?.[0]?.id || item.visitDetails?.healthlinkMessageId;

  const handleImport = () => {
    const res = items
      .filter((item) => selectedItems.includes(getItemId(item)))
      .map((item) => ({
        title:
          item.reportDetails?.orderDescription || getTestNames(item.results),
        hospital: item.visitDetails?.hospitalLab || "",
        date: formatDateForForm(item.visitDetails?.received),
        result: combineResults(item.results),
      }));

    addItemsToForm(res);
  };

  return (
    <>
      <div className={styles.vaccineDetailsWrapper}>
        <div className={styles.tablewrapper}>
          <div className={styles.table}>
            <div className={styles.tableHeader}>
              <div>
                <img
                  className={styles.menuIcon}
                  alt="checkbox"
                  src={checkboxIcon}
                />
              </div>
              <p>Test Name</p>
              <p>Date Received</p>
              <p>Hospital/Lab</p>
            </div>
            {selectedItems?.length > 0 && hasItems && (
              <div className={styles.tableSelectedItemsWrapper}>
                <div>
                  <p>{selectedItems?.length} items selected</p>
                  <button onClick={() => setSelectedItems([])}>Clear</button>
                </div>
              </div>
            )}
            {hasItems ? (
              <ul className={styles.tableItems}>
                {items.map((item) => {
                  const itemId = getItemId(item);
                  return (
                    <li key={itemId} className={styles.tableItem}>
                      <CustomCheckbox
                        checked={selectedItems.includes(itemId)}
                        handleChange={(e) => {
                          if (e.target.checked) {
                            setSelectedItems([...selectedItems, itemId]);
                          } else {
                            setSelectedItems(
                              selectedItems.filter((id) => id !== itemId)
                            );
                          }
                        }}
                      />
                      <p>
                        {item.reportDetails?.orderDescription ||
                          getTestNames(item.results)}
                      </p>
                      <p>{item.visitDetails?.received?.split(" ")[0] || "-"}</p>
                      <p>{item.visitDetails?.hospitalLab || "-"}</p>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div className={styles.emptyState}>
                <p className={styles.emptyStateTitle}>No results available</p>
                <p className={styles.emptyStateText}>
                  When results are ready they will appear in this list.
                </p>
              </div>
            )}
          </div>
        </div>
        <div className={styles.modalFooter}>
          <Button disabled={!selectedItems.length} onClick={handleImport}>
            Import
          </Button>
        </div>
      </div>
    </>
  );
};
